import { PlanDismiss } from '@/hooks/use-plan-dismiss';
import commonMessages from '@rhg/lang/messages/common';
import { CloseOutline } from '@rhg/libs/material/icons';
import { useIntl } from 'react-intl';
import { MoreMenuItem } from '../ui/more-menu';

interface PlanDismissMenuItemProps {
    planDismiss: PlanDismiss;
}

/** Dismiss option for a card's "..." menu; renders nothing when the recommendation isn't declinable. */
export function PlanDismissMenuItem({ planDismiss }: PlanDismissMenuItemProps) {
    const { formatMessage } = useIntl();

    if (!planDismiss.isDeclinable) return null;

    return (
        <MoreMenuItem
            trackButton="NotMapped"
            icon={<CloseOutline />}
            label={formatMessage(commonMessages['common.dismiss'])}
            disabled={planDismiss.isPending}
            onClick={planDismiss.dismiss}
        />
    );
}
